<template>
	<div class="box">
		<!-- 卡片 -->
		<div class="tab">
			<div class="tab_report">
				<div class="tab_txt">
					<span class="tab_txt1">我的报告</span>
					<span class="tab_txt2" @click="report">去查看
						<uni-icons type="forward" color="#fff" @click="report"></uni-icons>
					</span>
				</div>
				<image class="tab_img" src="../../static/baogao.png" mode=""></image>
			</div>

			<div class="tab_report">
				<div class="tab_txt">
					<span class="tab_txt1">个性化体检预约</span>
					<span class="tab_txt2" >
						去预约
						<uni-icons type="forward" color="#fff" ></uni-icons>
					</span>
				</div>
				<image class="tab_img" src="../../static/yuyue.png" mode=""></image>
			</div>

			<div class="tab_report">
				<div class="tab_txt">
					<span class="tab_txt1">个检预约</span>
					<span class="tab_txt2" @click="go">去预约
						<uni-icons type="forward" color="#fff" @click="go"></uni-icons>
					</span>
				</div>
				<image class="tab_img" src="../../static/yuyue.png" mode=""></image>
			</div>

			<div class="tab_report">
				<div class="tab_txt">
					<span class="tab_txt1">团检预约</span>
					<span class="tab_txt2">去预约
						<uni-icons type="forward" color="#fff"></uni-icons>
					</span>
				</div>
				<image class="tab_img" src="../../static/tuanti.png" mode=""></image>
			</div>
		</div>

		<!-- 特色功能 -->
		<div class="middle">
			<image class="middle_img" src="../../static/jiangpai.png" mode=""></image>
			<span class="middle_txt">特色功能</span>
		</div>

		<!-- 底部导航 -->
		<div class="bottom">
			<uni-collapse>
				<uni-collapse-item title="项目介绍" thumb="/static/xiangmujieshao.png">
					<div class="content">
						<text class="text">折叠内容主体，可自定义内容及样式</text>
					</div>
				</uni-collapse-item>
				<uni-collapse-item title="智能导检" thumb="/static/daohang.png">
					<div class="content">
						<text class="text">折叠内容主体，可自定义内容及样式</text>
					</div>
				</uni-collapse-item>
				<uni-collapse-item title="微官网" thumb="/static/guanwang.png">
					<div class="content">
						<text class="text">折叠内容主体，可自定义内容及样式</text>
					</div>
				</uni-collapse-item>
				<uni-collapse-item title="亲友报告" thumb="/static/xiangmujieshao.png">
					<div class="content">
						<text class="text">折叠内容主体，可自定义内容及样式</text>
					</div>
				</uni-collapse-item>
				<uni-collapse-item title="我的" thumb="/static/wode.png">
					<div class="content">
						<text class="text">折叠内容主体，可自定义内容及样式</text>
					</div>
				</uni-collapse-item>
			</uni-collapse>
			</uni-section>
		</div>


	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				value: ['0'],
				accordionVal: '1',
				content: '折叠内容主体，可自定义内容及样式，点击按钮修改内容使高度发生变化。',
				extraIcon: {
					color: '#4cd964',
					size: '26',
					type: 'image'
				},
			}
		},
		methods: {
			add() {
				if (this.content.length > 35) {
					this.content = '折叠内容主体，可自定义内容及样式，点击按钮修改内容使高度发生变化。'
				} else {
					this.content = '折叠内容主体，这是一段比较长内容。通过点击按钮修改后内容后，使组件高度发生变化，在次点击按钮恢复之前的内容和高度。'
				}
				// TODO 小程序中不支持自动更新 ，需要手动resize 更新组件高度
				// #ifdef MP
				this.$nextTick(() => {
					this.$refs.collapse.resize()
				})
				// #endif
			},
			onClick(e) {
				uni.showToast({
					title: '列表被点击'
				})
			},
			change(e) {
				console.log(e);
			},
			go() {
				uni.switchTab({
					url: '/pages/appointment/appointment'
				})
			},
			report() {
				uni.navigateTo({
					url: '/pages/ReportOverview/ReportOverview'
				})
			},
		}
	}
</script>

<style lang="scss">
	.box {
		width: 100%;
		min-height: 1460rpx;
		background: linear-gradient(180deg, #fd8b4d, #f4f8f7, #f7f7f7 70%, );
	}

	.tab {
		width: 100%;
		min-height: 400rpx;
		padding-top: 30rpx;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-around;
	}

	.tab_report {
		background-color: #ffffff;
		width: 300rpx;
		height: 200rpx;
		border-radius: 10%;
		display: flex;
		justify-content: space-around;
		margin-bottom: 25rpx;
	}

	.tab_txt {
		display: flex;
		flex-direction: column;
		justify-content: space-around;
	}

	.tab_txt1 {
		font-size: 12px;
	}

	.tab_txt2 {
		width: 65px;
		height: 20px;
		font-size: 12px;
		background-color: #fd8b4d;
		border-radius: 10px 10px 10px 10px;
		color: #ffffff;
		text-align: center;
	}

	.tab_txt2_img {
		width: 25rpx;
		height: 25rpx;
		margin-left: 5rpx;
		margin-top: 7rpx;
	}

	.tab_img {
		width: 120rpx;
		height: 120rpx;
		margin-top: 35rpx;
	}

	.middle {
		width: 345px;
		height: 40px;
		margin-left: 15px;
		display: flex;
		align-items: center;
		background-color: #ffffff;
	}

	.middle_img {
		width: 35px;
		height: 35px;
		margin-left: 10px;
	}

	.middle_txt {
		color: #df6b3e;
		margin-left: 6px;
		font-weight: 900;
	}

	.bottom {
		width: 345px;
		height: 40px;
		margin-left: 15px;
		margin-top: 10px;
		background-color: #ffffff;
	}

	.bottom_img {
		width: 25px;
		height: 25px;
	}

	.bottom_s {
		display: flex;
		flex-direction: row;
	}

	.example-body {
		flex-direction: column;
		flex: 1;
	}

	.content {
		padding: 15px;
	}

	.text {
		font-size: 14px;
		color: #666;
		line-height: 20px;
	}

	.button {
		// margin-top: 10px;
		margin: 10px;
		margin-bottom: 0;
	}
</style>
